import { render, staticRenderFns } from "./BrunetteFirstOpen.vue?vue&type=template&id=8067524a&"
import script from "./BrunetteFirstOpen.vue?vue&type=script&lang=ts&"
export * from "./BrunetteFirstOpen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports